import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import dayjs from 'Utilities/dayjs';
import { SOLD_CATEGORY } from 'Utilities/vehicleState';

const SERVICE_HISTORY_ENHANCED_ROLLOUT_DATE = '2026-01-22T15:30:00.000Z';

const HIDE_DETAILED_CARDS_APPLICABLE_STATES = [
	SOLD_CATEGORY.SOLD,
	SOLD_CATEGORY.SOLD_CONFIRMED,
	SOLD_CATEGORY.SOLD_DOCUMENTS_REVIEWED,
	SOLD_CATEGORY.SOLD_INVOICE_PAID,
	SOLD_CATEGORY.SOLD_INVOICE_RAISED,
	SOLD_CATEGORY.SOLD_PURCHASE_CONFIRMED,
];

export const useShouldHideDetailedServiceHistoryCards = (): boolean => {
	const { serviceHistory, state } = useVehicleData();
	const soldDate = serviceHistory?.soldDate;

	if (!soldDate || !state) {
		return false;
	}

	const parsedSoldDate = dayjs(soldDate);
	const parsedServiceHistoryRolloutDate = dayjs(SERVICE_HISTORY_ENHANCED_ROLLOUT_DATE);

	const isSoldDateBeforeRollout =
		parsedSoldDate.isValid() &&
		parsedServiceHistoryRolloutDate.isValid() &&
		parsedSoldDate.isBefore(parsedServiceHistoryRolloutDate);

	const isApplicableState = HIDE_DETAILED_CARDS_APPLICABLE_STATES.includes(state.slug);

	return Boolean(isSoldDateBeforeRollout && isApplicableState);
};
